/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 /* Noticed Quick View */
$(document).ready(function() {

	// Quickview Add To Cart

	function qvAddToCart(variant_id, qty) {

		let formData = {
			'items': [{
				'id': variant_id,
				'quantity': qty
			}]
		};

		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		})
		.then(response => response.json())
		.then(data => {

			if (data.message == "Cart Error") {
				let errorMessage = data.description;
				console.error(errorMessage);

				let errorMarkup = `
					<span class="ProductForm__Error Alert Alert--error">${errorMessage}</span>
				`
				$('.ProductForm').append(errorMarkup);
				$('.ProductForm__Error').delay('3000').fadeOut('slow');


			} else {
				$.fancybox.close();
				updateSidebarCart(data)
				updateHeaderCartCount();
			}
		})
		.catch((error) => {
			console.error('Error:', error);
		});
	}

	function updateHeaderCartCount() {

		// Get Cart
		fetch('/cart.js', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			}
		})
		.then(response => response.json())
		.then(data => {

			let cartCountDot = $('.Header__CartDot');
			cartCountDot.text(data.item_count);
			cartCountDot.addClass('is-visible');

		});
	}

	$('.Drawer__Close, .PageOverlay').click(function() {
		updateHeaderCartCount();
	});

	function updateSidebarCart(data) {

		// Get Cart
		fetch('/cart.js', {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			}
		})
		.then(response => response.json())
		.then(data => {

			let cartItems = data.items;
			let sidebarCart = $('#sidebar-cart');
			let cartContainer = $(sidebarCart).find('.Drawer__Main > .Drawer__Container').first();
			let cartFooter = $(sidebarCart).find('.Drawer__Footer').first();
			let formattedPrice = '$' + (data.total_price / 100);

			let cartFooterMarkup = `
			<div class="Drawer__Footer" data-drawer-animated-bottom="">
				<button type="button" class="Cart__NoteButton" data-action="toggle-cart-note">Add Order Note</button>
				<p class="Cart__Taxes Text--subdued">Shipping &amp; taxes calculated at checkout</p>
				<button type="submit" name="checkout" class="Cart__Checkout Button Button--primary Button--full">
					<span>Checkout</span>
					<span class="Button__SeparatorDot"></span>
					<span class="tdf-cart-total-parent">
						<span style="display:none" class="tdf-cart-total-flag"></span>
						${formattedPrice}
					</span>
				</button>
				<div class="Cart__OffscreenNoteContainer" aria-hidden="true">
					<span class="Cart__NoteButton">Add Order Note</span>
					<div class="Form__Item">
						<textarea class="Cart__Note Form__Textarea" name="note" id="cart-note" rows="3" placeholder="How can we help you?" data-scrollable=""></textarea>
					</div>
					<button type="button" class="Button Button--primary Button--full" data-action="toggle-cart-note">Save</button>
				</div>
			</div>
			`

			if (cartFooter.length > 0) {
				$('.tdf-cart-total-parent').text(formattedPrice);
			} else {
				$('#sidebar-cart .Drawer__Main').after(cartFooterMarkup);
			}

		if (cartContainer != undefined || cartContainer.length > 0) {
			let containerMarkup = `
			<div class="Drawer__Container">
				<div class="Cart__ItemList">
				</div>
			</div>
			`
			$('#sidebar-cart .Drawer__Main > .Drawer__Container').remove();
			$('.Cart__ShippingNotice').after(containerMarkup);
		} else {
			cartContainer.html('');
		}

			$('.Cart__Empty').hide();

			let itemList = sidebarCart.find('.Cart__ItemList');

			itemList.html('');
			cartContainer.html('');

			cartItems.map(function(item) {

				let title = item.title;
				let productImg = item.image;
				let formattedPrice = '$' + (item.price/100);

				let cartItemMarkup = `
				<div class="CartItemWrapper"><div class="CartItem">
							<div class="CartItem__ImageWrapper AspectRatio">
									<div class="AspectRatio" style="--aspect-ratio: 1.0">
										<img class="CartItem__Image" src="${productImg}" alt="${title}">
									</div>
								</div>

								<div class="CartItem__Info">
									<h2 class="CartItem__Title Heading">
										<a href="${item.url}">${title}<span class="tdf-cart-item-t"></span></a>
									</h2>

									<div class="CartItem__Meta Heading Text--subdued"><p class="CartItem__Variant">${item.variant_title}</p><ul class="CartItem__PropertyList"></ul><div class="CartItem__PriceList"><span class="CartItem__Price Price">${formattedPrice}</span></div></div><div class="CartItem__Actions Heading Text--subdued" style="text-align: center">
											<div class="CartItem__QuantitySelector">
												<div class="QuantitySelector"><a class="QuantitySelector__Button Link Link--primary" title="Set quantity to 0" href="/cart/change?quantity=0&amp;id=${item.key} data-quantity="${item.quantity - 1 }" data-line-id="${item.key}" data-action="update-item-quantity"><svg class="Icon Icon--minus" role="presentation" viewBox="0 0 16 2">
								<path d="M1,1 L15,1" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
							</svg></a>

													<input type="text" name="updates[]" id="updates_${item.key}" class="QuantitySelector__CurrentQuantity" pattern="[0-9]*" data-line-id="${item.key}" value="${item.quantity}"><a class="QuantitySelector__Button Link Link--primary" title="Set quantity to 2" href="/cart/change?quantity=2&amp;id=${item.key}" data-quantity="${item.quantity + 1}" data-line-id="${item.key}" data-action="update-item-quantity"><svg class="Icon Icon--plus" role="presentation" viewBox="0 0 16 16">
								<g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square">
									<path d="M8,1 L8,15"></path>
									<path d="M1,8 L15,8"></path>
								</g>
							</svg></a>
												</div>
											</div>

											<a href="/cart/change?quantity=0&amp;id=${item.key}" class="CartItem__Remove Link Link--underline Link--underlineShort" data-quantity="0" data-line-id="${item.key}" data-action="remove-item">Remove</a>
										</div>
								</div>
						</div>
				</div>
				`
				$(itemList).append(cartItemMarkup);

				// Show sidebarcart if it's hidden
				//$('.PageOverlay').addClass('is-visible');
				//$('#sidebar-cart').attr('aria-hidden', 'false');
			})
		});

	}

	$(document).on('click', '.quick-view-atc', function() {

		var variantId  = getCurrentVariantId();
		var quantitySelector = document.querySelector(".QuantitySelector select");
		var qty = quantitySelector.options[quantitySelector.selectedIndex].value;

		qvAddToCart(variantId,qty);

	});


  // Open with Fancybox
  $('body').on('click', '.trigger-qv', function(){
    $.fancybox.open({
      touch: false,
      type: 'ajax',
      src: $(this).data('src'),
      filter: '#quick-view',
      afterLoad: function() {
        if (document.querySelector('.product-thumbnails')) {
          $('.product-main-slider').slick({
            autoplay: false,
            draggable: true,
            focusOnSelect: true,
            infinite: true,
            arrows: false,
            slidesToShow: 1,
          });
        }
        var variantInventory;
        var colorOptions = document.querySelectorAll('.ColorSwatchList .HorizontalList__Item');
        var sizeOptions = document.querySelectorAll('.SizeSwatchList .HorizontalList__Item');
        var color = document.querySelector('.selected-variant');

				if (sizeOptions.length <= 0) {

					colorOptions.forEach(function(option) {

						option.addEventListener('click', function() {

							colorOptions.forEach(function(item) {
								item.classList.remove('selected-variant');
							});

							option.classList.add('selected-variant');
							showAvailableSizeOptions(option);
							//updateQuantitySelector(option);
						});
					});

				} else if (colorOptions.length <= 0) {
					// No Color Options
				} else {
					colorOptions.forEach(function(color) {
						color.addEventListener('click', function() {
							colorOptions.forEach(function(item) {
								item.classList.remove('selected-variant');
							});
							color.classList.add('selected-variant');
							showAvailableSizeOptions(color);
							//updateQuantitySelector(color);

							for ( let i = 0; i <= sizeOptions.length; i++) {
								var sizeInput = sizeOptions[i].firstElementChild;
								if (sizeInput.checked) {
								 sizeInput.removeAttribute('checked');
							 }
							 if (sizeOptions[i].classList.contains('size-unavailable') == false) {
								sizeInput.click();
								 break;
							 }
							}
						});
					});

				}

				if (colorOptions.length > 0) {
					colorOptions.forEach(function(option) {
						option.addEventListener('click', function() {
							let variantId = option.getAttribute('data-variant-id');
							goToVariantSlideImage(variantId);
						});
					});
				}

				hideOutOfStockColors();
        showAvailableSizeOptions(color);
        updateQuantitySelector(color);
      }
    });
  });
});

// Noticed Product Page Tabs
$(document).ready(function() {
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      /* Toggle between adding and removing the "active" class,
      to highlight the button that controls the panel */
      this.classList.toggle("active");

      /* Toggle between hiding and showing the active panel */
      var panel = this.nextElementSibling;
      if (panel != null) {
        if(panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      }
    });
  }
});

/* Noticed FAQ Accordions */
$(document).ready(function() {

	$('.faq__question').click(function(){
		var $faq = $(this).closest('.faq');
		$(this).next('.faq__answer').slideToggle(function(){
			$faq.toggleClass('faq--closed faq--open');

			// Update toggle button
			if($('.faq.faq--closed').length == 0) { // all are open
				$('.faq__toggle-all')
					.removeClass('faq__toggle-all--open')
					.addClass('faq__toggle-all--close')
					.text($('.faq__toggle-all').data('close'));
			} else if($('.faq.faq--open').length == 0) { // all are closed
				$('.faq__toggle-all')
					.removeClass('faq__toggle-all--close')
					.addClass('.faq__toggle-all--open')
					.text($('.faq__toggle-all').data('open'));
			}
		});
	});

	$('.faq__toggle-all').click(function(){
		if($(this).hasClass('faq__toggle-all--close')) { // close all
			$(this).text($(this).data('open'));
			$('.faq.faq--open .faq__answer').each(function(){
				var $faq = $(this).closest('.faq');
				$(this).slideUp(function(){
					$faq.toggleClass('faq--open faq--closed');
				});
			});
		} else { // open all
			$(this).text($(this).data('close'));
			$('.faq.faq--closed .faq__answer').each(function(){
				var $faq = $(this).closest('.faq');
				$(this).slideDown(function(){
					$faq.toggleClass('faq--open faq--closed');
				});
			});
		}

		$(this).toggleClass('faq__toggle-all--open faq__toggle-all--close');
	});

	// Open question on page load
	var faqId = window.location.hash;
	if($(faqId).length){
		$(faqId).find('.faq__question').click();
	}

});

$(document).ready(function() {
  /* Noticed Swatches */
  // update swatch selected value
	$('.ColorSwatch__Radio').change(function(){
		var value = $(this).val().split('(');
		$(this).closest('.ProductForm__Option').find('.selected-option').text(value[0]);
  });

  // Review Stars open accordion panel

  $('#product_just_stars').on('click', function() {
    $('#review-tab').show();
  });

  $(document).ready(function() {
    setTimeout(function(){
      $('#shopper_review_page').clone().appendTo('#mobile-reviews');
    },1000);

  });

  // Replace Adidas function call
  setTimeout(function(){
    adidasTransformation();
  },1000);

  // Fix height issue on shop the look slider
  if($carousel) {
    var $carousel = $('.Carousel').flickity()
    // jQuery
  $( window ).on( 'load', function() {
    $carousel.flickity('resize');
  });
  }

  // Fix coach sidebar menu close button
  $('.coach-close').on('click', function() {
    $('.coachSidebarMenu').attr('aria-hidden','true');
    $('html').removeClass('no-scroll');
  });

  // Hide nav on header hover

  var header = document.querySelector('.Header__Wrapper');
  var megaMenuItems = document.querySelectorAll('.MegaMenu');

  header.addEventListener('mouseenter', function() {
    megaMenuItems.forEach(item => {
      item.setAttribute('aria-hidden',true);
    });
  });

  // Searchbar JS

  var searchIcon = document.querySelector('a[data-action="toggle-search"]');
  var searchBar = document.querySelector('.Search');
  if (searchIcon) {
    searchIcon.addEventListener('click', () => {
      if ( searchBar.style.display != 'block' ) {
        searchBar.style.display = 'block';
      } else {
        searchBar.style.display = 'none';
      }
    });
  }

  // Make Collection Inner filters hidden until searchspring filters load
	setTimeout(() => {
		var oldCollectionFilters = document.querySelector('.CollectionInner__Sidebar .CollectionFilters');
		if (oldCollectionFilters != null) {
			oldCollectionFilters.classList.add('test');
		}
	}, 1000);

});


// Replace Adidas on every page

function adidasTransformation() {
  var html = document.querySelector('html');
  var walker = document.createTreeWalker(html, NodeFilter.SHOW_TEXT);
  var node;
  while (node = walker.nextNode()) {
    node.nodeValue = node.nodeValue.replace(/Adidas/, 'adidas')
  }
}

function linkCollectionPageImages() {

	$('body').on('click', '.CollectionMain .Grid__Cell .ProductItem .AspectRatio', function(e) {
		let url = $(e.target).parent('.AspectRatio').siblings('.ProductItem__ImageWrapper').attr('href');;
		window.location = url
	});

}

// PDP Image slider

function PDPSlide(slideNo){
  $('.vertical-thumbnails img').removeClass("active");
  $('.product-main-slider').slick('slickGoTo', slideNo);
  window.setTimeout(function(){
    $('.vertical-thumbnails #vertthumb-' + slideNo).addClass("active");
  }, 300)
}

// Carousel Instantiation

$('.collection-list-carousel').flickity({
  prevNextButtons: true,
  pageDots: false,
  contain: true,
  cellAlign: 'left',
  wrapAround: true,
  lazyLoad: false
});

$('.resource-carousel').flickity({
  wrapAround: true,
  arrows: false,
  cellAlign: 'left',
  contain: true,
  watchCSS: true,
  pageDots: false,
  imagesLoaded: false,
  adaptiveHeight: false
});

$('.hiw-carousel').flickity({
  wrapAround: true,
  arrows: false,
  cellAlign: 'left',
  contain: true,
  watchCSS: true,
  pageDots: false
});


// Add search button functionality

const searchButton = document.querySelector('.Search__InputIconWrapper');

// Add event to search button
searchButton.addEventListener('click', function() {
  const searchValue = document.querySelector('.Search__Input').value;
  // JED - Do not include the window.location.search in the URL...
  //const urlBuilder = `${window.location.search}?view=shop&q=${searchValue}`;
  const urlBuilder = `?view=shop&q=${searchValue}`;
  window.location.href = `/search${urlBuilder}`;
});
// Search upon pressing enter

var input = document.querySelector(".Search__Input");

// Execute a function when the user releases a key on the keyboard
input.addEventListener("keyup", function(event) {
  // Number 13 is the "Enter" key on the keyboard
  if (event.keyCode === 13) {
    // Cancel the default action, if needed
    event.preventDefault();
    // Trigger the button element with a click
    searchButton.click();
  }
});


// Custom Function

var colorOptions = document.querySelectorAll('.ColorSwatchList .HorizontalList__Item');
var sizeOptions = document.querySelectorAll('.SizeSwatchList .HorizontalList__Item');
var colorVariants = document.querySelectorAll('.color-variant');
var color = document.querySelector('.selected-variant');

if (colorOptions.length > 0) {
	colorOptions.forEach(function(color) {
		color.addEventListener('click', function() {

			showAvailableSizeOptions(color);
			updateThumbnailImage(color);

			for ( let i = 0; i <= sizeOptions.length; i++) {
				var sizeInput = sizeOptions[i].firstElementChild;

				if (sizeInput.checked) {
					sizeInput.removeAttribute('checked');
				}

				if (sizeOptions[i].classList.contains('size-unavailable') == false) {
					sizeInput.click();
					break;
				}
			}
		});
	});
}

function updateQuantitySelector() {

	let variantInventory = 0;
	var selectedColor = $('.ColorSwatch__Radio:checked').parent('.HorizontalList__Item').attr('data-option-1');

  var selectedSize = $('.SizeSwatch__Radio:checked + .SizeSwatch').parent('.HorizontalList__Item').attr('data-option-2');


	if (selectedColor) {
		$('.color-variant').each(function() {
			var color = $(this).attr('data-variant-option1');
			var size = $(this).attr('data-variant-option2');

			if (selectedColor == color && selectedSize == size) {
				variantInventory = $(this).data('variant-inventory-qty');
			} else if (selectedSize == undefined && selectedColor == color) {
				variantInventory = $(this).data('variant-inventory-qty');
			}
		});
	} else {
		selectedSize = $('.SizeSwatch__Radio:checked + .SizeSwatch').parent('.HorizontalList__Item').attr('data-option-1');

		$('.color-variant').each(function() {
			var size = $(this).attr('data-variant-option1');
			if (selectedSize == size) {
				variantInventory = $(this).data('variant-inventory-qty');
			}
		});
	}
	if(variantInventory > 0 ) {
		// Remove all child nodes
		var quantity = document.querySelector('.QuantitySelector .Select');

		function removeAllChildNodes(parent) {
            if(parent != null) {
    			while (parent.firstChild) {
    					parent.removeChild(parent.firstChild);
    			}
            }
		}

        if(quantity != null)
        {
    		removeAllChildNodes(quantity);
    
    		// Add the amount of nodes back into quantity selector
    		for ( let i = 1; i <= variantInventory; i++) {
    			var option = document.createElement('option');
    			option.setAttribute('value', i);
    			option.textContent = i;
    			quantity.appendChild(option);
    		}
    
    		// Update inventory left text
    		//console.log(variantInventory);
    		var inventoryLeftSelector = document.querySelector('.ProductForm__Inventory.only__left');
    		if ( variantInventory > 5 ) {
    			inventoryLeftSelector.innerHTML = `${variantInventory} left in stock!`;
    		} else {
    			inventoryLeftSelector.innerHTML = 'Low in stock!';
    		}
        }
	}


}

function goToVariantSlideImage(variantId) {

	var slideImgs = document.querySelectorAll('.image-gallery .productImageWrapper:not(.slick-cloned)');

	slideImgs.forEach(function(slideImg, i) {

		var slideIds = slideImg.getAttribute('data-variants');

		if (slideIds.indexOf(variantId) > -1) {
			$('.product-main-slider').slick('slickGoTo', i);
		}
	});
};

function getCurrentVariantId() {

  var selectedColor = $('.ColorSwatch__Radio:checked').parent('.HorizontalList__Item').attr('data-option-1');

  var selectedSize = $('.SizeSwatch__Radio:checked + .SizeSwatch').parent('.HorizontalList__Item').attr('data-option-2');

  var variantId;

	// We're checking to see if a product has color options at all.
	if (selectedColor) {

		$('.color-variant').each(function() {
			var color = $(this).attr('data-variant-option1');
			var size = $(this).attr('data-variant-option2');

			if (selectedColor == color && selectedSize == size) {
				variantId = $(this).data('variant-id');
			} else if (selectedSize == undefined && selectedColor == color) {
				variantId = $(this).data('variant-id');
			}

		});

		return variantId;

	} else {

		var selectedSize = $('.SizeSwatch__Radio:checked + .SizeSwatch').parent('.HorizontalList__Item').attr('data-option-1');

		$('.color-variant').each(function() {
			var size = $(this).attr('data-variant-option1');
			if (selectedSize == size) {
				variantId = $(this).data('variant-id');
			}
		});

		return variantId;
	}

}


$('.ProductForm__Variants .HorizontalList__Item').click(function() {
  // var currentVariantid = getCurrentVariantId();
	getCurrentVariantId();

});

function hideOutOfStockColors() {

  var colorVariants = document.querySelectorAll('.color-variant');
	var colorOptions = document.querySelectorAll('.ColorSwatchList .HorizontalList__Item');
	var sizeOptions = document.querySelectorAll('.SizeSwatchList .HorizontalList__Item');

	colorOptions.forEach(function(colorOption) {
		let currentColor = colorOption.getAttribute('data-option-1');
		let inventoryQty = 0;

		colorVariants.forEach(function(colorVar) {
			let color = colorVar.getAttribute('data-variant-option1');
			if (currentColor == color) {

				let qty = parseInt(colorVar.getAttribute('data-variant-inventory-qty'))
				inventoryQty = inventoryQty + qty;

			}
		});

		if (inventoryQty <= 0) {
			colorOption.classList.add('swatch-unavailable');
		}

	});
}

$(document.body).on('click', '.SizeSwatchList .HorizontalList__Item', function() {
	updateQuantitySelector();
})

function showAvailableSizeOptions(color) {


	var selectedOption = color;
	var noColorOptions = false;
	var noSizeOptions = false;

  var currentSizeArray = [];

	// Assigning variables for all the list of all product variants and selectors
  var colorVariants = document.querySelectorAll('.color-variant');
	var colorOptions = document.querySelectorAll('.ColorSwatchList .HorizontalList__Item');
	var sizeOptions = document.querySelectorAll('.SizeSwatchList .HorizontalList__Item');

	if (selectedOption ===  null) {
		console.log(selectedOption);
		var selectedOption = document.querySelector('.SizeSwatch__Radio:checked').parentNode;
		console.log(selectedOption);
		noColorOptions = true;
	}

	if (sizeOptions.length == 0) {
		noSizeOptions = true;
	}

	colorVariants.forEach(function(colorVar) {
		if (colorVar.getAttribute('data-variant-option1') == selectedOption.getAttribute('data-option-1')) {
			var availableSize = colorVar.getAttribute('option2');
			currentSizeArray.push(availableSize);
		}
	});

	if (noSizeOptions) {

		var addToCartBtn = document.querySelector('.ProductForm__AddToCart');

		colorOptions.forEach(function(colorSelector) {

			colorSelector.classList.add('color-unavailable');

			colorVariants.forEach(function(variant) {

				let inventory = parseInt(variant.getAttribute('data-variant-inventory-qty'));
				let colorAttr = variant.getAttribute('data-variant-option1');

				if (inventory > 0) {
					if(colorAttr == colorSelector.getAttribute('data-option-1')){
						colorSelector.classList.remove('color-unavailable');
					}
				}

			});
		});
	}

	if (noColorOptions) {
		var addToCartBtn = document.querySelector('.ProductForm__AddToCart');

		// Only one option

		sizeOptions.forEach(function(sizeSelector) {

			sizeSelector.classList.add('size-unavailable');
			sizeSelector.removeEventListener('click');

			colorVariants.forEach(function(variant) {
				let variantAvailable = variant.getAttribute('data-variant-available');
				let sizeAttr = variant.getAttribute('data-variant-option2') == '' ? variant.getAttribute('data-variant-option1') : variant.getAttribute('data-variant-option2');

				if (
					variantAvailable &&
					sizeAttr == sizeSelector.getAttribute('data-option-1')
				) {
					sizeSelector.classList.remove('size-unavailable');
				}

				if (inventory > 0) {
					if (sizeSelector.getAttribute('data-option-1') == sizeAttr) {
						addToCartBtn.removeAttribute('disabled');
						addToCartBtn.setAttribute('data-drawer-id','sidebar-cart');
					}
				}
			});
		});

	} else if (!noSizeOptions) {

		// Product has both size and color options
		// Loop through size selector thumbnails

		sizeOptions.forEach(function(sizeSelector){

			// Make all sizes unavailable by default
			sizeSelector.classList.add('size-unavailable');

			var selectorValueSize = sizeSelector.getAttribute('data-option-2');
			var selectorValueInventory;
			var selectorValueAvailable;
			var addToCartBtn = document.querySelector('.ProductForm__AddToCart');

			var sizeValue = sizeSelector.getAttribute('data-option-2');

			// Loop through utility list of variants

			colorVariants.forEach(function(variant) {

				if (
					variant.getAttribute('data-variant-option1') == selectedOption.getAttribute('data-option-1') &&
					variant.getAttribute('data-variant-option2') == sizeValue
				) {

					selectorValueInventory = variant.getAttribute('data-variant-inventory-qty');
					var variantAvailable = variant.getAttribute('data-variant-available') == 'true';

					if (variantAvailable) {
						sizeSelector.classList.remove('size-unavailable');
					}
				}
			});
		}); // End sizeOptions loop
	}
}

function updateThumbnailImage(color) {
  var bigImage = document.querySelector('.Product__SlideItem.is-selected img');
    if (color) {
      var variantImage = color.getAttribute('data-featured-img');
    }
    bigImage.setAttribute('srcset', variantImage);
}

$ ( document ).ready(function() {
	if ($('.CollectionToolbar').length > 0) {
		setTimeout(function(){
			document.querySelector('.CollectionToolbar').style.visibility = 'visible';
		},2500);
	}
});

$(document).ready(function() {

	// We only need to run these on the product pages
	// Quickview should handle them separately

	if( $('body').hasClass('template-product')) {
		showAvailableSizeOptions(color);
		hideOutOfStockColors();
		updateThumbnailImage(color);
	}

	linkCollectionPageImages();
});


